import AdminDetails from "./admin-details";

export default AdminDetails